/**
 * 쇼핑몰 메인 Presenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Banner, Popup } from 'components';

import CategoryList from './components/CategoryList';
import BestSellers from './components/BestSellers';
import NewProducts from './components/NewProducts';
import EventList from './components/EventList';
import RegularDelivery from './components/RegularDelivery';
import BestReviews from './components/BestReviews';

import './MainPresenter.style.css';
import TimeSale from './components/TimeSale';
import Recipe from './components/Recipe';
import AdBanner from './components/AdBanner';
import Brand from './components/Brand';

const giftTabs = [
  {
    key: 'specialty blend',
    label: 'Specialty blend',
  },
  {
    key: 'single origin',
    label: 'Single origin',
  },
  {
    key: 'dripbag',
    label: 'Dripbag',
  },
  {
    key: 'coffee supplies',
    label: 'Coffee Supplies',
  },
  {
    key: 'goods',
    label: 'Goods',
  },
];

/**----------------------------------------
 * [Component] 쇼핑몰 > 메인: 프레젠터
 * ----------------------------------------
 */
const MainPresenter = (props) => {
  /* ===== PROPS ===== */
  const {
    banner,
    popup,
    isPopup,
    setIsPopup,
    screenSize,
    products,
    groups,
    categories,
    onCartList,
    events,
    promotions,
    timeSale,
    userInfo,
    brands,
  } = props;
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const newPromotions = promotions.filter(
    (item) => item?.is_main === 'Y' && item?.promotion_type !== 'TIME_SALE',
  );
  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <React.Fragment>
      <Content
        maxWidth={'100%'}
        padding={0}
        style={{ overflow: 'hidden' }}
        className="main"
      >
        {/* 배너 */}
        <Row>
          <Col x={24}>
            <Banner slides={banner} />
          </Col>
        </Row>
        {/* 배너 끝 */}

        {/*광고배너 추가 요청 - 250527*/}
        <Row>
          <Col x={24}>
            <Content
              maxWidth={1500}
              padding={screenSize >= 768 ? '48px 0px 0px' : '24px 15px 0px'}
              style={screenSize >= 768 ? null : { marginBottom: 20 }}
              // margin={screenSize >= 768 ? null : '10'}
            >
              <AdBanner type={screenSize >= 768 ? 'pc' : 'mobile'} />
            </Content>
          </Col>
        </Row>
        {/*광고배너 추가 요청 - 250527*/}

        {/* ===== New logic===== */}
        {/* <Content
          maxWidth={'100%'}
          padding={0}
          style={{
            width:
              screenSize >= 768 ? 'calc(100% - 60px)' : 'calc(100% - 30px)',
          }}
        >
          <CategoryList
            userInfo={userInfo}
            screenSize={screenSize}
            categories={categories}
          />
        </Content> */}

        <Content
          maxWidth={'100%'}
          padding={0}
          style={{
            width:
              screenSize >= 768 ? 'calc(100% - 60px)' : 'calc(100% - 30px)',
          }}
        >
          <BestSellers
            products={products}
            giftTabs={giftTabs}
            screenSize={screenSize}
          />
        </Content>
        <br />
        <br />
        <br />
        <br />
        <NewProducts
          products={products}
          giftTabs={giftTabs}
          screenSize={screenSize}
        />
        <br />
        <br />
        <br />
        {/* SECTION: 이벤트 */}
        <Content
          maxWidth={'100%'}
          padding={0}
          style={{
            width:
              screenSize >= 768 ? 'calc(100% - 60px)' : 'calc(100% - 30px)',
          }}
        >
          <EventList
            title={'JM Event'}
            data={events}
            dataKey={'event'}
            path={'events'}
            screenSize={screenSize}
            tag={'Event'}
          />
        </Content>
        {/* !SECTION: 이벤트 */}
        <br />
        <br />
        <br />

        {/* SECTION: 타임세일 */}
        {timeSale.length ? (
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              backgroundColor: 'var(--begie-secondary-color)',
              padding: screenSize >= 768 ? '100px 0px' : '80px 0',
            }}
          >
            <TimeSale
              data={timeSale}
              products={products}
              screenSize={screenSize}
            />
          </Content>
        ) : null}
        {/* !SECTION: 타임세일 */}

        {/* SECTION: 프로모션 */}
        {newPromotions.length ? (
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              width:
                screenSize >= 768 ? 'calc(100% - 60px)' : 'calc(100% - 30px)',
            }}
          >
            <EventList
              title={'Promotion'}
              data={newPromotions}
              dataKey={'promotion'}
              path={'promotion'}
              screenSize={screenSize}
              tag={'Promo'}
            />
          </Content>
        ) : null}

        {/* !SECTION: 프로모션 */}

        {/* SECTION: 레시피 */}
        {groups?.length ? (
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              width:
                screenSize >= 768 ? 'calc(100% - 60px)' : 'calc(100% - 30px)',
            }}
          >
            <Recipe
              products={groups}
              giftTabs={giftTabs}
              screenSize={screenSize}
              onSubmit={onCartList}
            />
          </Content>
        ) : null}
        {/* !SECTION: 레시피 */}
        {/* SECTION: 브랜드 */}
        <Content
          maxWidth={'100%'}
          padding={0}
          style={{
            width:
              screenSize >= 768 ? 'calc(100% - 60px)' : 'calc(100% - 30px)',
          }}
          backgroundColor="#F8F8F8"
        >
          <Brand brands={brands} products={products} screenSize={screenSize} />
        </Content>
        {/* !SECTION: 브랜드 */}

        {/* SECTION: 정기배송 */}
        <RegularDelivery
          products={products}
          giftTabs={giftTabs}
          screenSize={screenSize}
        />
        {/* !SECTION: 정기배송 */}

        {/* SECTION: 베스트리뷰 */}
        <BestReviews
          products={products}
          giftTabs={giftTabs}
          screenSize={screenSize}
        />
        {/* !SECTION: 베스트리뷰 */}

        {/* ===== Old logic===== */}
        {/* Category */}
        {/* <Row>
          <Col x={24}>
            <Content maxWidth={1820} padding={0} style={{ marginTop: 200 }}>
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={20}>
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    style={{
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Title
                        style={{ ...styles.title }}
                        className="dela-gothic"
                      >
                        Category
                      </Title>
                      <div
                        style={{
                          width: 52,
                          height: 52,
                          borderRadius: '50%',
                          background: 'var(--black-color)',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          color: 'var(--white-color)',
                          cursor: 'pointer',
                          fontSize: 14,
                        }}
                        onClick={() =>
                          handleToggleSwiper('category', isPlaying['category'])
                        }
                      >
                        {isPlaying['category'] ? (
                          <PauseOutlined />
                        ) : (
                          <CaretRightOutlined />
                        )}
                      </div>
                    </div>

                    <div style={{ marginTop: 100 }}>
                      <Slider
                        spaceBetween={60}
                        slidesPerView={'auto'}
                        style={{ overflow: 'visible' }}
                        itemStyle={{ width: 380 }}
                        items={categories}
                        modules={['Autoplay']}
                        autoplay={{
                          delay: 3000,
                          disableOnInteraction: false,
                        }}
                        onSwiper={(swiper) =>
                          setSwiperObj((prev) => ({
                            ...prev,
                            category: swiper,
                          }))
                        }
                        render={(props, index, state) => (
                          <CategoryCard
                            {...props}
                            style={{
                              marginTop: (index + 1) % 2 === 0 ? 120 : 0,
                            }}
                          />
                        )}
                      />
                    </div>
                  </Content>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* Category 끝 */}

        {/* Best Sellers */}
        {/* <Row gutter={16}>
          <Col x={24}>
            <Content maxWidth={1820} padding={0} style={{ marginTop: 200 }}>
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={8} style={{ zIndex: 2 }}>
                  <Content
                    maxWidth={'100%'}
                    backgroundColor="none"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      height: '100%',
                    }}
                  >
                    <Title style={{ ...styles.title }} className="dela-gothic">
                      Best Sellers
                    </Title>

                    <div style={{ marginTop: 24 }}>
                      <ProductItem.Tags
                        tags={[
                          { id: 1, label: '특가' },
                          { id: 2, label: '무료배송' },
                        ]}
                        style={{ marginBottom: 4 }}
                      />
                      <ProductItem.Title
                        title={'시그니처블레드 617th 에비뉴 200g'}
                      />
                      <ProductItem.Review
                        review={{ score: 5, comment: 77 }}
                        style={{ marginTop: 16 }}
                      />
                      <ProductItem.Price
                        price={24000}
                        discount={50}
                        type={'%'}
                        style={{ marginTop: 16 }}
                      />
                    </div>

                    <div style={{ marginTop: 52 }}>
                      <Button
                        className="dela-gothic"
                        style={{ padding: '18px 52px', fontSize: 14 }}
                      >
                        View More
                      </Button>
                    </div>

                    <ul
                      style={{
                        marginTop: 80,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {[1, 2, 3].map((_item, _index) => (
                        <li
                          key={_index}
                          onClick={() => handleGoToSlide('best', _index)}
                          style={{
                            ...styles.bullet,
                            background:
                              swiperObj.best?.realIndex === _index
                                ? 'var(--black-color)'
                                : 'transparent',
                          }}
                        ></li>
                      ))}
                    </ul>
                  </Content>
                </Col>
                <Col x={12} style={{ zIndex: 1 }}>
                  <div>
                    <Slider
                      items={new Array(3).fill(null)}
                      modules={['EffectCoverflow', 'Autoplay', 'Pagination']}
                      effect={'coverflow'}
                      grabCursor={true}
                      centeredSlides={true}
                      loop={true}
                      slidesPerView={'auto'}
                      coverflowEffect={{
                        rotate: 0,
                        stretch: '100%',
                        depth: 50,
                        modifier: 1,
                        slideShadows: false,
                      }}
                      autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                      }}
                      style={{ overflow: 'visible' }}
                      itemStyle={{
                        width: 596,
                        height: 742,
                      }}
                      render={(_item, _index, { isNext, isPrev }) => {
                        return (
                          <div
                            style={{
                              width: '100%',
                              height: '100%',
                              transform: isNext
                                ? `rotate(10deg) translate(0, 7%)`
                                : isPrev && `rotate(-10deg) translate(0, -7%)`,
                              transformOrigin: `bottom right`,
                            }}
                          >
                            <img
                              src={img[_index]}
                              alt=""
                              style={{ width: '100%', height: '100%' }}
                            />
                          </div>
                        );
                      }}
                      onSwiper={(swiper) =>
                        setSwiperObj((prev) => ({
                          ...prev,
                          best: swiper,
                        }))
                      }
                      onSlideChange={(swiper) =>
                        setSwiperObj((prev) => ({
                          ...prev,
                          best: swiper,
                        }))
                      }
                    />
                  </div>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* Best Sellers 끝 */}

        {/* Jmcoffee's Roasters */}
        {/* <Row>
          <Col x={24}>
            <Content
              maxWidth={1820}
              padding={'140px 0px 100px'}
              style={{ marginTop: 200 }}
              backgroundColor="var(--begie-secondary-color)"
            >
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={10}>
                  <Content
                    maxWidth={'100%'}
                    backgroundColor="none"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      height: '100%',
                    }}
                  >
                    <Title style={{ ...styles.title }} className="dela-gothic">
                      Jmcoffee's
                      <br />
                      Roasters
                    </Title>

                    <div style={{ marginTop: 24 }}>
                      <p
                        style={{
                          ...styles.subTitle,
                        }}
                      >
                        JMCOFFEE는 커피를 찾는 모든 사람들이 풍부한 커피 경험을
                        <br />
                        공유하고 지속 가능한 커피 문화를 함께 만들어가는 커피
                        전문 기업입니다.
                      </p>
                    </div>

                    <div style={{ marginTop: 52 }}>
                      <Button
                        className="dela-gothic"
                        style={{ padding: '18px 52px', fontSize: 14 }}
                      >
                        View More
                      </Button>
                    </div>
                  </Content>
                </Col>
                <Col x={2}></Col>
                <Col x={8}>
                  <div>
                    <img src={Roasters} alt="JMCOFFEE" />
                  </div>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* Jmcoffee's Roasters 끝 */}

        {/* New arrivals */}
        {/* <Row>
          <Col x={24}>
            <Content maxWidth={1820} padding={0} style={{ marginTop: 200 }}>
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={8} style={{ zIndex: 2 }}>
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    style={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    <Title style={{ ...styles.title }} className="dela-gothic">
                      New arrivals
                    </Title>

                    <div style={{ marginTop: 24 }}>
                      <p
                        style={{
                          ...styles.subTitle,
                        }}
                      >
                        다양한 커피 음료 문화를 선도하는 브랜드
                        <br />
                        런칭 기념 20% 추가 할인
                      </p>
                    </div>

                    <div style={{ marginTop: 52 }}>
                      <Button
                        className="dela-gothic"
                        style={{ padding: '18px 52px', fontSize: 14 }}
                      >
                        View More
                      </Button>
                    </div>

                    <ul
                      style={{
                        marginTop: 80,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {[1, 2].map((_item, _index) => (
                        <li
                          key={_index}
                          onClick={() => handleGoToSlide('new', _index)}
                          style={{
                            ...styles.bullet,
                            background:
                              swiperObj.new?.realIndex === _index
                                ? 'var(--black-color)'
                                : 'transparent',
                          }}
                        ></li>
                      ))}
                    </ul>
                  </Content>
                </Col>
                <Col x={12} style={{ zIndex: 1 }}>
                  <div>
                    <Slider
                      items={new Array(2).fill(null)}
                      modules={['EffectCoverflow', 'Autoplay', 'Pagination']}
                      effect={'coverflow'}
                      grabCursor={true}
                      centeredSlides={true}
                      loop={true}
                      slidesPerView={'auto'}
                      coverflowEffect={{
                        rotate: 0,
                        stretch: '100%',
                        depth: 50,
                        modifier: 1,
                        slideShadows: false,
                      }}
                      autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                      }}
                      style={{ overflow: 'visible' }}
                      itemStyle={{
                        width: 596,
                        height: 742,
                      }}
                      render={(_item, _index, { isNext, isPrev }) => {
                        return (
                          <div
                            style={{
                              width: '100%',
                              height: '100%',
                              transform: isNext
                                ? `rotate(10deg) translate(0, 7%)`
                                : isPrev && `rotate(-10deg) translate(0, -7%)`,
                              transformOrigin: `bottom right`,
                            }}
                          >
                            <img
                              src={img[_index]}
                              alt=""
                              style={{ width: '100%', height: '100%' }}
                            />
                          </div>
                        );
                      }}
                      onSwiper={(swiper) =>
                        setSwiperObj((prev) => ({
                          ...prev,
                          new: swiper,
                        }))
                      }
                      onSlideChange={(swiper) =>
                        setSwiperObj((prev) => ({
                          ...prev,
                          new: swiper,
                        }))
                      }
                    />
                  </div>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* New arrivals 끝 */}

        {/* Today Deal, Take It */}
        {/* <Row>
          <Col x={24}>
            <Content
              maxWidth={1820}
              padding={'200px 0px'}
              style={{ marginTop: 200 }}
              backgroundColor="var(--begie-secondary-color)"
            >
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={10}>
                  <Content maxWidth={'100%'} padding={0} backgroundColor="none">
                    <div>
                      <div>
                        <Timer
                          start={moment().format('YYYY-MM-DD 00:00:00')}
                          end={moment().format('YYYY-MM-DD 23:59:59')}
                        />
                      </div>

                      <Title
                        style={{ ...styles.title, marginTop: 12 }}
                        className="dela-gothic"
                      >
                        Today Deal,
                        <br />
                        Take It
                      </Title>

                      <div style={{ marginTop: 24 }}>
                        {products && swiperObj.time_sale ? (
                          <>
                            <ProductItem.Tags
                              tags={
                                products[swiperObj.time_sale?.realIndex]?.tags
                              }
                              style={{ marginBottom: 4 }}
                            />
                            <ProductItem.Title
                              title={
                                products[swiperObj.time_sale?.realIndex]?.title
                              }
                            />
                            <ProductItem.Review
                              review={
                                products[swiperObj.time_sale?.realIndex]?.review
                              }
                              style={{ marginTop: 16 }}
                            />
                            <ProductItem.Price
                              price={
                                products[swiperObj.time_sale?.realIndex]?.price
                              }
                              discount={
                                products[swiperObj.time_sale?.realIndex]
                                  ?.discount
                              }
                              type={
                                products[swiperObj.time_sale?.realIndex]
                                  ?.discount_type
                              }
                              style={{ marginTop: 16 }}
                            />
                          </>
                        ) : (
                          <Skeleton active />
                        )}
                      </div>

                      <div style={{ marginTop: 52 }}>
                        <Button
                          className="dela-gothic"
                          style={{ padding: '18px 52px', fontSize: 14 }}
                        >
                          View More
                        </Button>
                      </div>

                      <ul
                        style={{
                          marginTop: 80,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {products.map((_item, _index) => (
                          <li
                            key={_index}
                            style={{
                              width: 12,
                              height: 12,
                              borderRadius: '50%',
                              border: '3px solid var(--black-color)',
                              display: 'inline-block',
                              marginRight: 12,
                              cursor: 'pointer',
                              background:
                                swiperObj.time_sale?.realIndex === _index
                                  ? 'var(--black-color)'
                                  : 'transparent',
                            }}
                          ></li>
                        ))}
                      </ul>
                    </div>
                  </Content>
                </Col>
                <Col x={2}></Col>
                <Col x={8}>
                  <div>
                    <Slider
                      items={products}
                      loop={true}
                      modules={['Autoplay']}
                      autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                      }}
                      onSwiper={(swiper) =>
                        setSwiperObj((prev) => ({
                          ...prev,
                          time_sale: swiper,
                        }))
                      }
                      onSlideChange={(swiper) =>
                        setSwiperObj((prev) => ({
                          ...prev,
                          time_sale: swiper,
                        }))
                      }
                      render={(_item, _index, _state) => (
                        <div>
                          <img src={_item.src} alt={_item.title} />
                        </div>
                      )}
                    />
                  </div>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* Today Deal, Take it 끝 */}

        {/* Gift Giving */}
        {/* <Row>
          <Col x={24}>
            <Content maxWidth={1820} padding={0} style={{ marginTop: 200 }}>
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={20}>
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    backgroundColor="none"
                    style={{ height: '100%' }}
                  >
                    <Title style={{ ...styles.title }} className="dela-gothic">
                      Gift Giving
                    </Title>

                    <Tabs
                      items={giftTabs}
                      fullscreen={false}
                      layoutStyle={{ border: 'none' }}
                      style={{
                        fontSize: 24,
                        padding: 0,
                        marginRight: 40,
                        marginTop: 60,
                      }}
                      textStyle={{
                        fontFamily: `${'Dela Gothic One'}, sans-serif`,
                        padding: 2,
                        lineHeight: '38px',
                      }}
                      activeColor={'var(--black-color)'}
                    />

                    <Row gutter={[16, 100]} style={{ marginTop: 100 }}>
                      {products.map((_item, _index) => (
                        <Col x={8} key={`product_${_index}`}>
                          <ProductItem
                            src={Product}
                            title={_item.title}
                            tags={_item.tags}
                            review={_item.review}
                            price={_item.price}
                            discount={_item.discount}
                            discountType={_item.discount_type}
                            hovered
                          />
                        </Col>
                      ))}
                    </Row>

                    <div
                      style={{
                        marginTop: 100,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        className="dela-gothic"
                        style={{ padding: '18px 52px', fontSize: 14 }}
                      >
                        View More
                      </Button>
                    </div>
                  </Content>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* Gift Giving 끝 */}

        {/* This Way, It Taste Even Better */}
        {/* <Row>
          <Col x={24}>
            <Content
              maxWidth={1820}
              padding={'200px 0px'}
              style={{ marginTop: 200 }}
              backgroundColor="var(--begie-secondary-color)"
            >
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={20}>
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    backgroundColor="none"
                    style={{ height: '100%' }}
                  >
                    <Title style={{ ...styles.title }} className="dela-gothic">
                      This Way,
                      <br />
                      It Taste Even Better
                    </Title>

                    <Row gutter={100} style={{ marginTop: 100 }}>
                      <Col x={16}>
                        <Slider
                          items={products}
                          spaceBetween={16}
                          slidesPerView={3}
                          itemStyle={{ width: '30%' }}
                          onSwiper={(swiper) =>
                            setSwiperObj((prev) => ({
                              ...prev,
                              group_products: swiper,
                            }))
                          }
                          render={(props, index, state) => (
                            <div style={{ width: '100%' }}>
                              <ProductItem.Image
                                src={GroupProduct}
                                hovered={false}
                              />
                              <div style={{ width: '80%' }}>
                                <ProductItem.Title
                                  title={props.title}
                                  style={{ fontSize: 18 }}
                                  maxLine={2}
                                />
                                <ProductItem.Price
                                  price={props.price}
                                  discount={props.discount}
                                  type={props.discount_type}
                                  style={{ marginTop: 12, fontSize: 22 }}
                                />
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: 32,
                                  }}
                                >
                                  <Button
                                    type="secondary"
                                    style={{
                                      background: 'transparent',
                                      fontFamily: `${'Dela Gothic One'}, sans-serif`,
                                      fontSize: 14,
                                      fontWeight: 400,
                                      lineHeight: '22px',
                                      width: '70%',
                                      height: 58,
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                    }}
                                  >
                                    Add to box
                                  </Button>
                                  <Button
                                    type="secondary"
                                    style={{
                                      background: 'transparent',
                                      width: 58,
                                      height: 58,
                                      padding: 0,
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <img src={Heart} alt="찜하기" />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          )}
                        />
                      </Col>
                      <Col x={8}>
                        <div>
                          <Title
                            style={{ ...styles.title, fontSize: 28 }}
                            className="dela-gothic"
                          >
                            Category
                          </Title>

                          <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                          >
                            {giftTabs.map((_item, _index) => (
                              <Checkbox
                                value={_item.label}
                                style={{ fontSize: 18 }}
                              >
                                {_item.label}
                              </Checkbox>
                            ))}
                          </div>
                        </div>

                        <div style={{ marginTop: 80 }}>
                          <Title
                            style={{ ...styles.title, fontSize: 28 }}
                            className="dela-gothic"
                          >
                            Order details
                          </Title>

                          <div style={{ marginTop: 16 }}>
                            <div>
                              {[1].map((_item, _index) => (
                                <div
                                  key={`order_${_index}`}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: 16,
                                  }}
                                >
                                  <div style={{ cursor: 'pointer' }}>
                                    <img src={Close} alt="delete" />
                                  </div>
                                  <div style={{ width: 73 }}>
                                    <img
                                      src={GroupProduct}
                                      alt="상품"
                                      style={{ width: '100%' }}
                                    />
                                  </div>
                                  <div>
                                    <ProductItem.Title
                                      title="시그니처 블렌드 617th 에비뉴 200g"
                                      maxLine={2}
                                      style={{ fontSize: 18 }}
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>

                            <div
                              style={{
                                borderTop: '2px solid',
                                borderBottom: '1px solid',
                                borderColor: 'var(--black-color)',
                                padding: '14px 0',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: 18,
                                color: 'var(--black-color)',
                              }}
                            >
                              <p className="dela-gothic">total</p>
                              <p className="dela-gothic">
                                {stringToMoneyFormat(12000)}
                              </p>
                            </div>
                          </div>

                          <div style={{ marginTop: 40 }}>
                            <Button
                              style={{
                                width: '100%',
                                height: 58,
                                fontSize: 14,
                              }}
                              className="dela-gothic"
                            >
                              Add to Cart
                            </Button>

                            <Button
                              style={{
                                width: '100%',
                                height: 58,
                                fontSize: 14,
                                background: 'transparent',
                                marginTop: 8,
                              }}
                              className="dela-gothic"
                              type="secondary"
                            >
                              Add to wish list
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Content>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* This Way, It Taste Even Better 끝 */}

        {/* Special Exhibition */}
        {/* <Row>
          <Col x={24}>
            <Content maxWidth={1820} padding={0} style={{ marginTop: 200 }}>
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={20}>
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    style={{
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Title
                        style={{ ...styles.title }}
                        className="dela-gothic"
                      >
                        Special Exhibition
                      </Title>
                      <div
                        style={{
                          width: 52,
                          height: 52,
                          borderRadius: '50%',
                          background: 'var(--black-color)',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          color: 'var(--white-color)',
                          cursor: 'pointer',
                          fontSize: 14,
                        }}
                        onClick={() =>
                          handleToggleSwiper('category', isPlaying['category'])
                        }
                      >
                        {isPlaying['category'] ? (
                          <PauseOutlined />
                        ) : (
                          <CaretRightOutlined />
                        )}
                      </div>
                    </div>

                    <div style={{ marginTop: 100 }}>
                      <Slider
                        spaceBetween={'3.33%'}
                        slidesPerView={'auto'}
                        style={{ overflow: 'visible' }}
                        itemStyle={{ width: '30%' }}
                        items={special}
                        modules={['Autoplay']}
                        autoplay={{
                          delay: 3000,
                          disableOnInteraction: false,
                        }}
                        onSwiper={(swiper) =>
                          setSwiperObj((prev) => ({
                            ...prev,
                            special: swiper,
                          }))
                        }
                        render={(props, index, state) => (
                          <div
                            style={{
                              marginTop: (index + 1) % 2 === 0 ? 120 : 0,
                            }}
                          >
                            <div>
                              <img src={props.src} alt={props.title} />
                            </div>
                            <Text
                              maxLine={2}
                              size={20}
                              weight={700}
                              style={{ marginTop: 32 }}
                            >
                              {props.title}
                            </Text>
                            <Text
                              size={14}
                              weight={400}
                              color={'#666666'}
                              style={{ marginTop: 8 }}
                            >
                              {moment(props.start_date).format('YYYY. MM. DD')}{' '}
                              - {moment(props.end_date).format('YYYY. MM. DD')}
                            </Text>
                          </div>
                        )}
                      />
                    </div>

                    <div
                      style={{
                        marginTop: 100,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        className="dela-gothic"
                        style={{ padding: '18px 52px', fontSize: 14 }}
                      >
                        View More
                      </Button>
                    </div>
                  </Content>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* Special Exhibition 끝 */}

        {/* Highlight Brands */}
        {/* <Row gutter={16}>
          <Col x={24}>
            <Content maxWidth={1820} padding={0} style={{ marginTop: 200 }}>
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={8} style={{ zIndex: 2 }}>
                  <Content
                    maxWidth={'100%'}
                    backgroundColor="none"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      height: '100%',
                    }}
                  >
                    <Title style={{ ...styles.title }} className="dela-gothic">
                      Highlight
                      <br />
                      Brands
                    </Title>

                    <div style={{ marginTop: 24 }}>
                      <ProductItem.Tags
                        tags={[
                          { id: 1, label: '특가' },
                          { id: 2, label: '무료배송' },
                        ]}
                        style={{ marginBottom: 4 }}
                      />
                      <ProductItem.Title
                        title={'시그니처블레드 617th 에비뉴 200g'}
                      />
                      <ProductItem.Review
                        review={{ score: 5, comment: 77 }}
                        style={{ marginTop: 16 }}
                      />
                      <ProductItem.Price
                        price={24000}
                        discount={50}
                        type={'%'}
                        style={{ marginTop: 16 }}
                      />
                    </div>

                    <div style={{ marginTop: 52 }}>
                      <Button
                        className="dela-gothic"
                        style={{ padding: '18px 52px', fontSize: 14 }}
                      >
                        View More
                      </Button>
                    </div>

                    <ul
                      style={{
                        marginTop: 80,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {[1, 2].map((_item, _index) => (
                        <li
                          key={_index}
                          onClick={() => handleGoToSlide('brands', _index)}
                          style={{
                            ...styles.bullet,
                            background:
                              swiperObj.brands?.realIndex === _index
                                ? 'var(--black-color)'
                                : 'transparent',
                          }}
                        ></li>
                      ))}
                    </ul>
                  </Content>
                </Col>
                <Col x={12} style={{ zIndex: 1 }}>
                  <div>
                    <Slider
                      items={new Array(2).fill(null)}
                      modules={['EffectCoverflow', 'Autoplay', 'Pagination']}
                      effect={'coverflow'}
                      grabCursor={true}
                      centeredSlides={true}
                      loop={true}
                      slidesPerView={'auto'}
                      coverflowEffect={{
                        rotate: 0,
                        stretch: '100%',
                        depth: 50,
                        modifier: 1,
                        slideShadows: false,
                      }}
                      autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                      }}
                      style={{ overflow: 'visible' }}
                      itemStyle={{
                        width: 596,
                        height: 742,
                      }}
                      render={(_item, _index, { isNext, isPrev }) => {
                        return (
                          <div
                            style={{
                              width: '100%',
                              height: '100%',
                              transform: isNext
                                ? `rotate(10deg) translate(0, 7%)`
                                : isPrev && `rotate(-10deg) translate(0, -7%)`,
                              transformOrigin: `bottom right`,
                            }}
                          >
                            <img
                              src={img[_index]}
                              alt=""
                              style={{ width: '100%', height: '100%' }}
                            />
                          </div>
                        );
                      }}
                      onSwiper={(swiper) =>
                        setSwiperObj((prev) => ({
                          ...prev,
                          brands: swiper,
                        }))
                      }
                      onSlideChange={(swiper) =>
                        setSwiperObj((prev) => ({
                          ...prev,
                          brands: swiper,
                        }))
                      }
                    />
                  </div>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* Highlight Brands 끝 */}

        {/* Regular Delivery */}
        {/* <Row>
          <Col x={24}>
            <Content maxWidth={1820} padding={0} style={{ marginTop: 200 }}>
              <Row gutter={16}>
                <Col x={2}></Col>
                <Col x={20}>
                  <Content
                    maxWidth={'100%'}
                    padding={0}
                    backgroundColor="none"
                    style={{ height: '100%' }}
                  >
                    <Title style={{ ...styles.title }} className="dela-gothic">
                      Regular Delivery
                    </Title>

                    <Tabs
                      items={giftTabs}
                      fullscreen={false}
                      layoutStyle={{ border: 'none' }}
                      style={{
                        fontSize: 24,
                        padding: 0,
                        marginRight: 40,
                        marginTop: 60,
                      }}
                      textStyle={{
                        fontFamily: `${'Dela Gothic One'}, sans-serif`,
                        padding: 2,
                        lineHeight: '38px',
                      }}
                      activeColor={'var(--black-color)'}
                    />

                    <Row gutter={[16, 100]} style={{ marginTop: 100 }}>
                      {products.map((_item, _index) => (
                        <Col x={8} key={`product_${_index}`}>
                          <ProductItem
                            src={Product}
                            title={_item.title}
                            tags={_item.tags}
                            review={_item.review}
                            price={_item.price}
                            discount={_item.discount}
                            discountType={_item.discount_type}
                            hovered
                          />
                        </Col>
                      ))}
                    </Row>

                    <div
                      style={{
                        marginTop: 100,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        className="dela-gothic"
                        style={{ padding: '18px 52px', fontSize: 14 }}
                      >
                        View More
                      </Button>
                    </div>
                  </Content>
                </Col>
                <Col x={2}></Col>
              </Row>
            </Content>
          </Col>
        </Row> */}
        {/* Regular Delivery 끝 */}

        {/* Best Review */}
        {/* <Row>
          <Col x={24}>
            <Content
              maxWidth={'100%'}
              padding={'200px 0px'}
              // style={{ marginTop: 200 }}
              backgroundColor="var(--begie-secondary-color)"
            >
              <Content
                maxWidth={1820}
                padding={0}
                style={{ marginTop: 200 }}
                backgroundColor="none"
              >
                <Row gutter={16}>
                  <Col x={2}></Col>
                  <Col x={20}>
                    <Content
                      maxWidth={'100%'}
                      padding={0}
                      backgroundColor="none"
                      style={{ height: '100%' }}
                    >
                      <Title
                        style={{ ...styles.title }}
                        className="dela-gothic"
                      >
                        Best Review
                      </Title>

                      <Tabs
                        items={giftTabs}
                        fullscreen={false}
                        layoutStyle={{ border: 'none' }}
                        style={{
                          fontSize: 24,
                          padding: 0,
                          marginRight: 40,
                          marginTop: 60,
                        }}
                        textStyle={{
                          fontFamily: `${'Dela Gothic One'}, sans-serif`,
                          padding: 2,
                          lineHeight: '38px',
                        }}
                        activeColor={'var(--black-color)'}
                      />

                      <div style={{ marginTop: 100 }}>
                        <Slider
                          spaceBetween={'3.33%'}
                          slidesPerView={'auto'}
                          style={{ overflow: 'visible' }}
                          itemStyle={{ width: '30%' }}
                          items={products}
                          modules={['Autoplay']}
                          autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                          }}
                          loop={true}
                          onSwiper={(swiper) =>
                            setSwiperObj((prev) => ({
                              ...prev,
                              review: swiper,
                            }))
                          }
                          render={(props, index, state) => (
                            <div>
                              <ProductItem.Image
                                src={Product}
                                hovered={false}
                              />
                              <Text
                                maxLine={2}
                                size={20}
                                weight={700}
                                style={{ marginTop: 32 }}
                              >
                                {props.title}
                              </Text>
                              <Text
                                size={14}
                                weight={400}
                                color={'#666666'}
                                style={{ marginTop: 8 }}
                                maxLine={2}
                              >
                                항상 애용하는 제품입니다. 좋아요.
                                추천합니다.항상 애용하는 제품입니다. 좋아요.
                                추천합니다.항상 애용하는 제품입니다. 좋아요.
                                추천합니다.항상 애용하는 제품입니다. 좋아요.
                                추천합니다.항상 애용하는 제품입니다. 좋아요.
                                추천합니다.항상 애용하는 제품입니다. 좋아요.
                                추천합니다.
                              </Text>

                              <div
                                style={{
                                  marginTop: 8,
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Text size={14} weight={400} color={'#666666'}>
                                  <StarOutlined />
                                  {parseFloat(props.review.score).toFixed(1)}
                                </Text>
                                <Text
                                  size={12}
                                  weight={400}
                                  color={'#BBBBBB'}
                                  style={{ padding: '0px 12px' }}
                                >
                                  |
                                </Text>
                                <Text size={14} weight={400} color={'#666666'}>
                                  jj******
                                </Text>
                              </div>
                            </div>
                          )}
                        />
                      </div>
                    </Content>
                  </Col>
                  <Col x={2}></Col>
                </Row>
              </Content>
            </Content>
          </Col>
        </Row> */}
        {/* Best Review 끝 */}
      </Content>

      {/* Popup */}
      <Popup
        isOpen={popup.length && isPopup}
        data={popup}
        onClose={() => setIsPopup(false)}
      />
      {/* Popup 끝 */}
    </React.Fragment>
  ); // JSX: end
};

export default MainPresenter;
